import React from 'react';
import styled from 'styled-components';
import { color } from '../../styles/mixins';
import { p14 } from '../../styles/typography';
import { useNow } from '../../utils/use-now';

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0 24px;
`;

const Host = styled.div`
  ${p14};
  display: flex;
  align-items: center;
  color: ${color('red60')};
`;

const Time = styled.time`
  margin-right: 4px;
`;
const Text = styled.p``;

interface TimerProps {
  value: Date;
  text: string;
}

export const Timer = ({ value, text }: TimerProps) => {
  const now = useNow();
  const diff = Math.floor((new Date(value || now).getTime() - now) / 1000);
  const seconds = diff % 60;
  const minutes = Math.floor(diff / 60) % 60;
  const hours = Math.floor(diff / 60 / 60) % 24;
  const days = Math.floor(diff / 60 / 60 / 24);

  const output = [days, hours, minutes, seconds]
    .map((v, i) =>
      i === 0 && v === 0 ? null : (v || 0).toString().padStart(2, '0')
    )
    .filter((n) => !!n)
    .join(':');

  if (diff <= 0) {
    return null;
  }

  return (
    <Wrap>
      <Host>
        <Time>{output}</Time>
        <Text>{text}</Text>
      </Host>
    </Wrap>
  );
};
